import { getApi } from "./api_instance";

export const getAllCategories = async (logout) => {
  try {
    const { data } = await getApi({
      apiUrl: "/admin/projects/api/categories",
      logout,
    });
    return data;
  } catch (error) {
    return error;
  }
};
